import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Table, TableBody, Paper, Typography, Toolbar, Grid, TextField } from '@material-ui/core';
import { Home as HomeIcon, NavigateNext as NavigateIcon } from '@material-ui/icons';
import BillOfLadingToolbar from './BillOfLadingToolbar';
import BillOfLadingDetailsTableHead from './BillOfLadingDetailsTableHead';
import { successMessage, genericErrorMessage } from '../../actions/messageActions';
import { getContainerBOL, getVesselstayBOL } from '../../api/consignmentApi';
import { mapBillOfLading } from '../../mappers/billOfLadingMapper';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import BillOfLadingDetail from './BillOfLadingDetail';

const styles = theme => ({
  checkbox: {
    padding: 8,
    margin: '0 4px',
  },
  nextMode: {
    fill: '#606060',
  },
  content: {
    padding: theme.spacing.unit * 5,
    paddingTop: theme.spacing.unit * 13,
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing.unit * 12,
    },
    height: '100vh',
    overflowY: 'scroll',
  },
  buttonAdd: {
    position: 'fixed',
    right: 16,
    bottom: 0,
    margin: theme.spacing.unit * 3,
  },
  tableFooter: {
    height: 40,
  },
  sortedByLabel: {
    flex: 1,
    margin: 'auto 0',
    marginLeft: 18,
  },
  dataColumn: {
    padding: theme.spacing.unit * 3,
  },
  noWrapContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > div': {
      width: '46%',
    },
  },
  navigation: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 40,
    paddingLeft: theme.spacing.unit * 3,
  },
  capitalize: {
    textTransform: 'uppercase',
  },
  navigate: {
    color: theme.palette.text.secondary,
    width: theme.spacing.unit * 6,
  },
  link: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  copy: {
    left: -7,
  },
});

class BillOfLading extends React.Component {
  state = {
    order: 'desc',
    orderBy: '',
    selected: [],
    billOfLading: {
      customsResponse: {
        dataProvider: '',
        response: '',
        description: '',
      },
      vesselDetails: {
        imo: '',
        cargoAgent: '',
        consignmentNumber: '',
      },
      voyageInformation: {
        portOfLoading: '',
        portOfDestination: '',
      },
      stayInformation: {
        stayNumber: '',
        berthPlace: '',
      },
      details: [],
    },
  };

  handleRequestSort = (event, property) => {
    // const orderBy = property;
    // let order = 'desc';
    // if (this.state.orderBy === property && this.state.order === 'desc') {
    //   order = 'asc';
    // }
    // this.setState({ order, orderBy });
  };

  handleSelectAllClick = event => {
    if (event.target.checked) {
      // eslint-disable-next-line
      this.setState(state => ({
        selected: state.billOfLading.details.map(n => n.itemNumber),
      }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleSelect = (event, id) => {
    event.stopPropagation();

    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  copyDetail = detail => {
    return [
      'itemNumber',
      'commodity',
      'packageType',
      'quantity',
      'grossWeight',
      'grossWeightUnit',
      'customsStatus',
    ]
      .map(property => `"${detail[property]}"`)
      .join(', ');
  };

  performCopy = clipBoard => {
    const tempInput = document.createElement('textarea');
    tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
    tempInput.value = clipBoard;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
  };

  handleCopySelected = () => {
    const selectedRows = this.state.selected.map(selected =>
      this.state.billOfLading.details.find(detail => detail.itemNumber === selected)
    );
    this.performCopy(selectedRows.map(this.copyDetail).join('\n'));
    this.props.successMessage(`Successfully copied ${selectedRows.length} rows to clipboard.`);
  };

  handleCopy = detail => {
    this.performCopy(this.copyDetail(detail));
    this.props.successMessage('Successfully copied row to clipboard.');
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  async componentDidMount() {
    try {
      let billOfLading;
      if (this.props.match.params.containerNumber) {
        billOfLading = await getContainerBOL(
          this.props.match.params.billOfLading,
          this.props.match.params.containerNumber
        );
      } else {
        billOfLading = await getVesselstayBOL(
          this.props.match.params.billOfLading,
          this.props.match.params.vesselStay
        );
      }
      this.setState({
        billOfLading: mapBillOfLading(billOfLading),
      });
    } catch (err) {
      this.props.genericErrorMessage(err);
    }
  }

  render() {
    const {
      classes,
      match: {
        params: { billOfLading },
      },
    } = this.props;
    const {
      billOfLading: { details },
      order,
      orderBy,
      selected,
    } = this.state;

    return (
      <main className={classes.content}>
        <div className={classes.navigation}>
          <Link to="/">
            <HomeIcon className={classes.link} />
          </Link>
          <NavigateIcon className={classes.navigate} />
          <Link to="/">
            <Typography
              variant="subtitle2"
              className={classNames(classes.capitalize, classes.link)}
            >
              Import Consignment
            </Typography>
          </Link>
          <NavigateIcon className={classes.navigate} />
          <Link to={this.props.location.pathname}>
            <Typography
              variant="subtitle2"
              className={classNames(classes.capitalize, classes.link)}
            >
              {billOfLading}
            </Typography>
          </Link>
        </div>
        <Paper>
          <Toolbar>
            <Typography variant="h5" style={{ marginRight: 10 }}>
              Bill of Lading
            </Typography>
            <Typography variant="subtitle2" color="textSecondary" className={classes.capitalize}>
              {billOfLading}
            </Typography>
          </Toolbar>
          <Grid container>
            <Grid item xs={3} className={classes.dataColumn}>
              <Typography variant="h5" id="tableTitle">
                Customs response
              </Typography>
              <TextField
                id="dataProvider"
                label="Data provider"
                value={this.state.billOfLading.customsResponse.dataProvider}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="response"
                label="Response"
                value={this.state.billOfLading.customsResponse.response}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="description"
                label="Description"
                value={this.state.billOfLading.customsResponse.description}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className={classes.dataColumn}>
              <Typography variant="h5" id="tableTitle">
                Vessel details
              </Typography>
              <TextField
                id="imo"
                label="IMO"
                value={this.state.billOfLading.vesselDetails.imo}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="cargoAgent"
                label="Cargo agent"
                value={this.state.billOfLading.vesselDetails.cargoAgent}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="consignmentNumber"
                label="Consignment number"
                value={this.state.billOfLading.vesselDetails.consignmentNumber}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className={classes.dataColumn}>
              <Typography variant="h5" id="tableTitle">
                Voyage information
              </Typography>
              <TextField
                id="portOfLoading"
                label="Port of loading"
                value={this.state.billOfLading.voyageInformation.portOfLoading}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              <TextField
                id="portOfDestination"
                label="Port of discharge"
                value={this.state.billOfLading.voyageInformation.portOfDestination}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={3} className={classes.dataColumn}>
              <Typography variant="h5" id="tableTitle">
                Stay information
              </Typography>
              <TextField
                id="stayNumber"
                label="Stay number"
                value={this.state.billOfLading.stayInformation.stayNumber}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
              {/* <div className={classes.noWrapContainer}>
                <TextField
                  id="standard-read-only-input"
                  label="Expected arrival"
                  value={formatDateNumericMonth(
                    this.state.billOfLading.stayInformation.expectedArrival
                  )}
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                  className={classes.wrappedFields}
                />
                <TextField
                  id="standard-read-only-input"
                  label="Expected departure"
                  value={formatDateNumericMonth(
                    this.state.billOfLading.stayInformation.expectedDeparture
                  )}
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                  className={classes.wrappedFields}
                />
              </div> */}
              <TextField
                id="berthPlace"
                label="Berthplace"
                value={this.state.billOfLading.stayInformation.berthPlace}
                margin="normal"
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <BillOfLadingToolbar
            numSelected={selected.length}
            handleCopySelected={this.handleCopySelected}
          />
          <Table aria-labelledby="tableTitle">
            <BillOfLadingDetailsTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={details.length}
            />
            <TableBody>
              {this.state.billOfLading.details.map(detail => {
                return (
                  <BillOfLadingDetail
                    key={detail.itemNumber}
                    detail={detail}
                    isSelected={this.isSelected(detail.itemNumber)}
                    handleSelect={this.handleSelect}
                    handleCopy={this.handleCopy}
                  />
                );
              })}
            </TableBody>
          </Table>
          <div className={classes.tableFooter} />
        </Paper>
      </main>
    );
  }
}

BillOfLading.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      successMessage,
      genericErrorMessage,
    },
    dispatch
  );
}

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(BillOfLading));
